import { Layout, LayoutType } from '@common/data-models/service/layout';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PlanningViewsResults } from '@src/suite/common/data-models/navigation/planning-views-results';
import { RundownPanelAttach } from '@src/suite/live/store/models/live.models';

export const LiveActions = createActionGroup({
    source: 'Live',
    events: {
        // 'Add rundown': props<Wire>(),
        // 'Remove rundown': props<Wire>(),
        'Define rundown comparators': emptyProps(),
        'Open Rundown Full Screen': emptyProps(),
        'Open Rundown Story Full Screen': props<{ guid: string }>(),
    },
});

export const LiveApiActions = createActionGroup({
    source: 'Rundown API',
    events: {
        // 'Load rundowns': props<{ poll: boolean; vs?: ViewStateRecord }>(),
        'Load Current Rundown': props<{ data: StorytellingRundownRecord; panelAttach: RundownPanelAttach }>(),
        'Start polling': props<{ interval: number }>(),
        'Stop polling': props<{ restart: boolean }>(),
        'Load Current Rundown success': props<{ data: StorytellingRundownRecord }>(),
        'Load Current Rundown error': props<{ error: string }>(),
        'Load rundowns success': props<{ rundowns: Array<StorytellingRundownRecord> }>(),
        'Load rundowns error': props<{ error: string }>(),
        'Load rundown stored layouts': emptyProps(),
        'Load rundown stored layouts success': props<{ data: string[] }>(),
        'Load rundown stored layouts error': props<{ error: string }>(),
        'Load rundown layout': props<{ layoutType: LayoutType; name?: string }>(),
        'Load rundown layout success': props<{ data: Layout }>(),
        'Load rundown layout error': props<{ error: string }>(),
        'Freeze rundown pages': props<{ guid: string }>(),
        'Freeze rundown pages success': props<{ data: { pages: string[]; pagesFrozen: boolean } }>(),
        'Freeze rundown pages error': props<{ error: string }>(),
        'On Air': props<{ data?: { [id: string]: any }; guid: string }>(),
        'Mos control active': props<{ data?: { [id: string]: any }; guid: string }>(),
        'Mos ready to air': props<{ data?: { [id: string]: any }; guid: string }>(),
        'Lock Rundown': props<{ data?: { [id: string]: any }; guid: string }>(),
        'Update current Rundown': props<{ data: { [id: string]: any }; guid: string }>(),
        'Add rundown story': props<{ scriptDatabase: string; scriptPath: string; scriptGuid: string; insertBeforeGuid: string; guid: string; propertiesToOverride: { [id: string]: any } }>(),
        'Insert rundown row': props<{ database: string; collectionPath: string; collectionGuid: string; insertBeforeGuid: string; fieldsToUpdate: { [id: string]: any } }>(),
        'Add rundown story success': props<{ data: StorytellingRundownRecord }>(),
        'Update rundown story': props<{ propID: string; guid: string; value: { [id: string]: any }; rowIndex: number }>(),
        'Update rundown story success': props<{ data: StorytellingRecord }>(),
        'Update rundown story error': props<{ error: string }>(),
        // 'Mos story send': props<{ data: { send: boolean } }>(),
        'Load rundown view states': emptyProps(),
        'Load rundown view states success': props<{ data: PlanningViewsResults }>(),
    },
});
